/**
 * @Author: zhangxiaojian
 * @Date: 2025/11/12
 * @LastEditors: zhangxiaojian
 * @Description 小程序平台相关接口
 **/

import { createAPI } from '@common'
export default {
  // 小程序详情
  appletDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bqqmfu0efubjm', 'get', config, {
      timeout: 86400000
    }),
  // 保存或新建小程序
  appletSave: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bqqmfu0tbwf', 'post', config, {
      timeout: 86400000
    })
}
